export default "__VITE_ASSET__CQURi1IT__"